<template>
    <LeftAsideSubLayout title="Manufacturers">
        <template #aside>
            <div ref="asideScroller" class="h-full overflow-auto w-full">
                <div
                    class="py-1 sticky top-0 bg-gray-tier-3 z-10 border-b border-keyline-primary"
                    :class="{ 'shadow-lg': isScrolled }"
                >
                    <SeclockMultiselect
                        class="m-4"
                        :options="manufacturers?.filter((manufacturer) => manufacturer.logo)?.map((manufacturer) => ({'label': manufacturer.name,'value': manufacturer.slug}))"
                        :placeholder="$t('Choose a manufacturer')"
                        :searchable="true"
                        :can-clear="false"
                        :large="false"
                        @change="navigateToShow($event)"
                    />
                </div>
                <span class="p-6 pb-0 block w-full type-secondary">
                    {{ $t("Categories") }}
                </span>
                <SideNavAlt
                    class="w-full p-4"
                    :sections="tagArray"
                    :click-to-scroll="false"
                    :all="true"
                    v-model="selectedTag"
                />
            </div>
        </template>
        <template #default>
            <ManufacturerContent
                class=""
                :manufacturers="filteredManufacturers"
                :tags="tags['vendor-category']"
                :external-nav="true"
                :selected-tag="selectedTag"
            />
        </template>
    </LeftAsideSubLayout>
</template>

<script setup>
import {ManufacturerContent, SeclockMultiselect, SideNavAlt} from "@/Components";
import {LeftAsideSubLayout} from "@/Layouts";
import {computed, inject, onMounted, onUnmounted, reactive, ref} from "vue";
import {router, usePage} from "@inertiajs/vue3";

const route = inject("route");
const props = defineProps(["manufacturers", "tags"]);
const query = reactive(usePage().props.query ?? {});
const tagArray = ref(props.tags['vendor-category']);

const selectedTag = computed({
    get: () => {
        return tagArray.value?.find((tag) => tag.name === query.tag);
    },
    set: (tag) => {
        query.tag = tag;
        if(tag){
            query.letter = null;
        }
    },
});

const filteredManufacturers = computed(() => {
    let data = props.manufacturers;

    if (selectedTag.value) {
        return data.filter((manufacturer) =>
            manufacturer.tag_ids?.includes(selectedTag.value.id)
        );
    }

    if (query.letter) {
        return data.filter((manufacturer) =>
            manufacturer.name?.startsWith(query.letter.toLowerCase()) || manufacturer.name?.startsWith(query.letter.toUpperCase())
        );
    }

    return data;
});

// Scroll shadow handling for sticky header
const asideScroller = ref(null);
const isScrolled = ref(false);

const handleScroll = () => {
    isScrolled.value = (asideScroller.value?.scrollTop ?? 0) > 0;
};

onMounted(() => {
    asideScroller.value?.addEventListener('scroll', handleScroll);
    handleScroll();
});

onUnmounted(() => {
    asideScroller.value?.removeEventListener('scroll', handleScroll);
});

const navigateToShow = (slug) => {
    router.visit(route('web.catalog.manufacturers.show', slug))
};
</script>
